@if (component !== undefined) {
<app-zx-component-form [component]="component"></app-zx-component-form>
}
